import { Button, ButtonGroup } from 'reactstrap';
import { UNIT_OPTIONS, useUnitContext } from '../contexts/UnitContext';

const UnitToggle = ({ onChange, value: units, buttonClassName }) => (
  <ButtonGroup>
    {UNIT_OPTIONS.map(({ label, value }) => (
      <Button
        key={value}
        onClick={() => {
          if (units !== value) onChange(value);
        }}
        color={value === units ? 'primary' : 'secondary'}
        outline={value !== units}
        size="sm"
        className={buttonClassName}
      >
        {label}
      </Button>
    ))}
  </ButtonGroup>
);

export const ContextUnitToggle = (props) => {
  const { units, setUnits } = useUnitContext();
  return <UnitToggle value={units} onChange={setUnits} {...props} />;
};

export default UnitToggle;
